import { render, staticRenderFns } from "./couponGiveProvideEdit.vue?vue&type=template&id=e0daae22&"
import script from "./couponGiveProvideEdit.vue?vue&type=script&lang=js&"
export * from "./couponGiveProvideEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports